import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  padding: 6px;
  background-color: #0078bb;
`;

export const Container = styled.div`
  display: flex;
`;

export const Home = styled.img`
  height: 30px;
`;

export const Texto = styled.p`
  color: #ffffff; // FIXO
  margin: auto 0px auto 20px;
  font-size: 10pt;
`;

export const IconSefaz = styled.div`
  margin-left: auto;
  display: flex;
`;
